export default "__VITE_ASSET__ce2c53a8__"